var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.537109,
    width: 37.7285,
    height: 37.6598,
    rx: 18.8299,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5355 18.8302C26.5355 14.9091 23.3568 11.7304 19.4357 11.7304C15.5146 11.7304 12.3359 14.9091 12.3359 18.8302C12.3359 22.3739 14.9322 25.3111 18.3264 25.8438V20.8825H16.5237V18.8302H18.3264V17.266C18.3264 15.4866 19.3863 14.5038 21.0081 14.5038C21.7849 14.5038 22.5974 14.6424 22.5974 14.6424V16.3896H21.7021C20.8201 16.3896 20.5451 16.9369 20.5451 17.4984V18.8302H22.5142L22.1994 20.8825H20.5451V25.8438C23.9392 25.3111 26.5355 22.3739 26.5355 18.8302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookRounded);
export default __webpack_public_path__ + "static/media/facebook-rounded.23dfd9e252afefa76afdb41c1f7e3aaa.svg";
export { ForwardRef as ReactComponent };